import React from 'react';
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import { useTranslation } from 'react-i18next';
import { LoanProduct } from './LoanProducts';

export default function Welcome(props) {
    const { t, i18n } = useTranslation();
    const { rates, loantype, homePageTitle1, homePageTitle2, homePageTitle1Fr, homePageTitle2Fr } = props.data;

    return (
        <div>
            <div className="text-center font-semibold my-5 text-lg">{i18n.language === 'fr' && homePageTitle1Fr !== '' ? homePageTitle1Fr : homePageTitle1}</div>
            <h1 className="font-medium text-lg mb-5">{t('selectProduct')}</h1>
            <LoanProduct products={loantype} rates={rates} />
            <div className="border-t my-7 w-2/3 m-auto"></div>
            <h2 className="font-medium pb-1">{t('applyRequirement.title')}</h2>
            <div>
                <ul className="px-2 text-sm text-gray-500 space-y-1.5">
                    <li className="flex space-x-1">
                        <div>
                            <DoneOutlinedIcon className="text-green-600" fontSize="small" />
                        </div>
                        <div>{t('applyRequirement.canadian')}</div>
                    </li>
                    <li className="flex space-x-1">
                        <div>
                            <DoneOutlinedIcon className="text-green-600" fontSize="small" />
                        </div>
                        <div>{t('applyRequirement.age')}</div>
                    </li>
                    <li className="flex space-x-1">
                        <div>
                            <DoneOutlinedIcon className="text-green-600" fontSize="small" />
                        </div>
                        <div>{t('applyRequirement.bankruptcy')}</div>
                    </li>
                </ul>
            </div>
            <div className="mt-5 text-sm">{i18n.language === 'fr' && homePageTitle2Fr !== '' ? homePageTitle2Fr : homePageTitle2}</div>
        </div>
    );
}
